import { CurrencyPipe } from '@angular/common';
import { Component, inject, Input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { GravatarModule } from 'ngx-gravatar';

import { LazyLoadDirective } from '@bn/web-ui';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { BnClipboardService } from '@bn/web-ui/common-web/services';
import { DropdownMenuComponent } from '@bn/web-ui/dropdown-menu/dropdown-menu.component';
import { DropdownMenuItem } from '@bn/web-ui/dropdown-menu/models';

@Component({
  selector: 'bn-layout-user-profile',
  templateUrl: './user-profile.component.html',
  imports: [CurrencyPipe, RouterLink, GravatarModule, DropdownMenuComponent, FaIconComponent, LazyLoadDirective, BadgeComponent],
})
export class UserProfileComponent {
  private readonly clipboard = inject(BnClipboardService);

  @Input() menuItems: DropdownMenuItem[] = [];
  @Input() isMobile = false;
  @Input() email = '';
  @Input() fullName = '';
  @Input() accountRoute?: string;
  @Input() billingRoute?: string;
  @Input() billingBalance?: number;
  @Input() showBilling = false;

  readonly logout = output<void>();

  public onItemClick(menuItem: DropdownMenuItem): void {
    if (menuItem.action === 'logout') {
      this.logout.emit();
    }
  }

  public copyToClipboard(): void {
    this.clipboard.copyTextToClipboard(this.email, 'Email');
  }
}
